// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExportOutlinedSvg from "@fishx/icons-svg/es/asn/ExportOutlined";
import FishxIcon from '../components/FishxIcon';

var ExportOutlined = function ExportOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExportOutlinedSvg
  }));
};

ExportOutlined.displayName = 'ExportOutlined';
export default React.forwardRef(ExportOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ExportOutlined.js
// module id = 2643
// module chunks = 0